<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header hidden-lg-up" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        Overview <a class="btn btn-link help-icon p-0 invisible">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body px-lg-0 pt-0">
    <div class="col-lg-12 px-0">
      <app-information [appId]="appId" [data]="data" [os]="os" [device]="device" [region]="region" [month]="month"
        [numWatching]="numWatching" [isFollowing]="isFollowing" [isFreemium]="isFreemium" [isAnonymous]="isAnonymous"
        [processingFollow]="processingFollow" (toAppDiscovery)="toAppDiscovery.emit($event)"
        (followButtonBreakpointReached)="followButtonBreakpointReached.emit($event)"
        (followButtonClick)="followButtonClick.emit($event)" (anchorClick)="anchorClick.emit($event)"
        [selectedCountry]="selectedCountry"></app-information>
    </div>
  </div>
</div>